import { render } from "./upsertPlayerInjuryDialog.vue?vue&type=template&id=5ae7b233"
import script from "./upsertPlayerInjuryDialog.vue?vue&type=script&lang=js"
export * from "./upsertPlayerInjuryDialog.vue?vue&type=script&lang=js"

import "./upsertPlayerInjuryDialog.vue?vue&type=style&index=0&id=5ae7b233&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__